module.exports = __webpack_public_path__ + "media/images/background/2-2b868c0116764fb0a0413066188fcb98.jpg";